import { createContext, useContext } from 'react'
import type { User } from '@/lib/types'

export interface AuthContextType {
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  logout: () => void
}

// Context + hook live here (not in AuthContext.tsx) so the provider module can
// export only components (react-refresh/only-export-components).
export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
